import { Outlet } from 'react-router';
import { TenantLogo } from '../organization/TenantLogo';
import { ColorModeToggle } from '../theme/ColorModeToggle';

/**
 * Phone-first surface for the yard supervisor: a short task list, large
 * controls, on-behalf capture. Deliberately separate from the desktop tables.
 */
export function YardLayout() {
  return (
    <div className="min-h-screen bg-page">
      <header className="sticky top-0 z-10 flex h-14 items-center justify-between border-b border-line bg-surface/85 px-4 backdrop-blur">
        <div className="flex items-center gap-2.5">
          <TenantLogo size="yard" />
          <span className="rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-primary">Yard</span>
        </div>
        {/* Larger targets: this surface is used one-handed on a phone. */}
        <ColorModeToggle size="large" />
      </header>
      <main className="p-4">
        <Outlet />
      </main>
    </div>
  );
}
